module.exports = __webpack_public_path__ + "static/media/edis-kontakte.094022cc.svg";